import React from 'react'
import HeaderOne from '../Components/Header/HeaderOne'
import Breadcrumb from '../Components/BreadCrumb/Breadcrumb'
import BlogDetailsMain from '../Components/Blog/BlogDetailsMain'
import FooterFour from '../Components/Footer/FooterFour'
import ScrollToTop from '../Components/ScrollToTop'
import SEO from '../Components/SEO/SEO'

function BlogDetails() {
    return (
        <>
            <SEO 
                title="Blog Post - Tourm Travel Agency"
                description="Read our latest travel blog posts and articles. Get travel tips, guides, and inspiration."
                url="/blog"
            />
            <HeaderOne />
            <Breadcrumb
                title="Blog Single"
            />
            <BlogDetailsMain />
            <FooterFour />
            <ScrollToTop />
        </>
    )
}

export default BlogDetails
